import type { $Fetch } from 'ofetch';
import type { Desconto, DescontoSubtipo, CupomStatus, CriarDescontoCommand } from '@/domain/model/Desconto';
import type { Page } from '@/domain/model/Page';
import type { DescontoGateway } from '@/application/port/out/DescontoGateway';
import type { ApiResponse, SpringPage } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/descontos';

export class HttpDescontoGateway implements DescontoGateway {
  constructor(private readonly client: $Fetch) {}

  async list(p: { subtipo?: DescontoSubtipo; status?: CupomStatus; page?: number; size?: number }): Promise<Page<Desconto>> {
    const params: Record<string, string | number> = {};
    if (p.subtipo) params['subtipo'] = p.subtipo;
    if (p.status) params['status'] = p.status;
    if (typeof p.page === 'number') params['page'] = p.page;
    if (typeof p.size === 'number') params['size'] = p.size;
    const res = await this.client<ApiResponse<SpringPage<Desconto>>>(PATH, { method: 'GET', params });
    assertApiSuccess(res);
    const d = res.data;
    return { content: d.content, number: d.number, size: d.size, totalElements: d.totalElements, totalPages: d.totalPages, first: d.first, last: d.last };
  }

  async get(id: string): Promise<Desconto> {
    const res = await this.client<ApiResponse<Desconto>>(`${PATH}/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async criar(command: CriarDescontoCommand): Promise<Desconto> {
    const res = await this.client<ApiResponse<Desconto>>(PATH, { method: 'POST', body: command });
    assertApiSuccess(res);
    return res.data;
  }

  async ativar(id: string): Promise<Desconto> {
    const res = await this.client<ApiResponse<Desconto>>(
      `${PATH}/${encodeURIComponent(id)}/ativar`, { method: 'POST' },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async desativar(id: string): Promise<Desconto> {
    const res = await this.client<ApiResponse<Desconto>>(
      `${PATH}/${encodeURIComponent(id)}/desativar`, { method: 'POST' },
    );
    assertApiSuccess(res);
    return res.data;
  }
}
